module.exports = __webpack_public_path__ + "static/media/MX.4def2ac5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MX.svg
// module id = 323
// module chunks = 0